import { filter } from 'lodash';
import { useState, useEffect, useCallback } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  Box,
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Chip
} from '@mui/material';
// redux
import { useDispatch, useSelector } from '../../../../redux/store';
import { setEnviosList } from '../../../../redux/slices/dagpacket';
// utils
// eslint-disable-next-line
import { addOneDay, fDateTime } from '../../../../utils/formatTime';
import { fCurrency } from '../../../../utils/formatNumber';
// routes
// hooks
import useSettings from '../../../../hooks/useSettings';
// components
import Page from '../../../Page';
// import Label from '../../Label';
import Scrollbar from '../../../Scrollbar';
import SearchNotFound from '../../../SearchNotFound';
import { ProductListHead, Label } from '../../e-commerce/product-list';

import { firestore } from '../../../../contexts/FirebaseContext';
import CartCheckoutComplete from '../../cotenvio/checkout/CartCheckoutComplete';
import { clipPaymentConfirm, getConvertCompras, hacerEnvioRedpack } from '../../../../_apis_/dagpacket';
import useAuth from '../../../../hooks/useAuth';
import UserBasicInfo from '../general/UserBasicInfo';
import DialogCancelarEnvio from '../../paquetes/envios/DialogCancelarEnvio';
import EditarEnviosButton from './actions/EditarEnviosButton';
import { providerAbrev } from '../../../../utils/providerAbrev';
import EnvioListToolbar from './EnvioListToolbar';
import { useFilterByDate } from '../../../../hooks/useFilterByDate';
import useHandleFiltroFecha from '../../../../hooks/useHandleFiltroFecha';
import useDeepFilter from '../../../../hooks/useDeepFilter';
import { addDisplayNameToEnvios } from '../../../../utils/addDisplayName';
import useDescuentoFormat from '../../../../hooks/envios/useDescuentoFormat';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: '', label: '' },
  { id: 'id', label: '#', alignRight: false },
  { id: 'licenciatarioName', label: 'Licenciatario', alignRight: false },
  { id: 'displayName', label: 'Usuario', alignRight: false },
  { id: 'rate_provider', label: 'Paqueteria', alignRight: false },
  { id: 'created_at', label: 'Fecha', alignRight: false },
  { id: 'originalShippingValue', label: 'Precio original', alignRight: false },
  { id: 'shippingValue', label: 'Precio', alignRight: false },
  { id: 'costo', label: 'Costo', alignRight: false },
  { id: 'modificacion', label: 'Modificacion', alignRight: false },
  { id: 'cuponValue', label: 'Cupon', alignRight: false },
  { id: 'utilidad', label: 'Utilidad', alignRight: false },
  { id: 'utilidad_dag', label: 'U. dagpacket', alignRight: false },
  { id: 'utilidad_lic', label: 'U. licenciat.', alignRight: false },
  { id: 'city_from', label: 'Origen', alignRight: true },
  { id: 'city_to', label: 'Destino', alignRight: true },
  { id: 'state', label: 'Estado de pago', alignRight: true },
  { id: 'status', label: 'Estado de envio', alignRight: true }
  //   { id: 'orden', label: 'N° Orden', alignRight: false },
  //   { id: 'compra', label: 'N° Compra', alignRight: false },
  // { id: 'pago', label: 'Pago', alignRight: true },
  // { id: 'guia', label: 'Guia', alignRight: true },
  // { id: 'extra', label: 'Extra', alignRight: true },
  // { id: '' },
  // { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    return filter(
      array,
      (_product) => _product?.refenceValue?.toString().toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return stabilizedThis.map((el) => el[0]);
}

export default function ListaEnvioGeneral({ envios, userList }) {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [orderBy, setOrderBy] = useState('createdAt');
  const [statusEnvioSelected, setStatusEnvioSelected] = useState(['LABEL_CREATED']);
  const [empaqueValue, setEmpaqueValue] = useState('todos');
  const [updatedEnvios, setUpdatedEnvios] = useState([]);

  const [fecha, setFecha] = useState('');
  const { user } = useAuth();
  const { showModificacion } = useDescuentoFormat();

  const { handleDesde, handleHasta, handleResetFechas, hasta, desde } = useHandleFiltroFecha();

  const newHasta = addOneDay(hasta);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = envios.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - envios.length) : 0;

  const filterStatus = (data, selectedStatuses) => {
    if (selectedStatuses.length === 0) {
      return data;
    }

    const hasStatus = (status) => selectedStatuses.includes(status);

    return data.filter((item) => {
      if (hasStatus('QUOTE') && (item.status === 'QUOTE' || item.status === 'PURCHASE')) {
        return true;
      }
      if (hasStatus('LABEL_CREATED') && (item.status === 'LABEL_CREATED' || item.status === 'CREATED')) {
        return true;
      }
      if (hasStatus('PENDIENTE-CANCELACION') && item.state === 'PENDIENTE-CANCELACION') {
        return true;
      }
      if (hasStatus('CANCELADO') && item.status === 'CANCELADO') {
        return true;
      }

      return false;
    });
  };

  const filterEmpaqueValue = (data, value) => {
    if (value === 'con_empaque') {
      return data.filter((item) => item.empaquetado);
    }
    if (value === 'sin_empaque') {
      return data.filter((item) => !item.empaquetado);
    }

    return data;
  };

  const filterDate = useCallback((dataArr, initialDate, finalDate, compareDatePropName) => {
    const filteredData = dataArr.filter((item) => {
      // console.log(item);
      if (initialDate === '' && finalDate === '') {
        return item;
      }

      if (typeof item[compareDatePropName] === 'object') {
        if (
          item[compareDatePropName]?.toDate() >= (initialDate ? new Date(initialDate) : new Date('2017-05-24')) &&
          item[compareDatePropName]?.toDate() <= (finalDate ? new Date(finalDate) : new Date())
        ) {
          return item;
        }
      }
      return false;
    });

    return filteredData;
  }, []);

  const handleStatus = (selectedStatuses) => {
    setStatusEnvioSelected(selectedStatuses);
  };

  useEffect(() => {
    setUpdatedEnvios(addDisplayNameToEnvios(envios, userList));
  }, [envios, userList]);

  const { filteredDataByInput, searchTerm, setSearchTerm } = useDeepFilter(updatedEnvios);
  const filteredByEmapqueValue = filterEmpaqueValue(filteredDataByInput, empaqueValue);

  const filteredByStatus = filterStatus(filteredByEmapqueValue, statusEnvioSelected);

  const filteredByDate = filterDate(filteredByStatus, desde, newHasta, 'updated_at');

  const filteredProducts = applySortFilter(filteredByDate, getComparator(order, orderBy), filterName);
  const { filteredData } = useFilterByDate(filteredProducts, desde, newHasta, 'created_at');

  const isProductNotFound = filteredProducts.length === 0;
  // collection_status=approved
  // status=approved
  const handleFilterByName = (event) => {
    setSearchTerm(event.target.value);
    // setFilterName(event.target.value);
  };

  return (
    <Page title="Usuarios - Envios General">
      <Card>
        <Box display="flex" justifyContent="center" sx={{ margin: '15px 0' }}>
          <Typography component="h2" variant="h4">
            Envios
          </Typography>
        </Box>
        <Divider />
        <EnvioListToolbar
          numSelected={selected.length}
          filterName={searchTerm}
          // filterName={filterName}
          onFilterName={handleFilterByName}
          date={fecha}
          setDate={setFecha}
          handleStatus={handleStatus}
          handleEmpaqueVal={setEmpaqueValue}
          dataList={filteredData}
          hasReporte
          onDesdeDate={handleDesde}
          onHastaDate={handleHasta}
          handleResetFechas={handleResetFechas}
          desdeDate={desde}
          hastaDate={hasta}
          statusEnvioSelected={statusEnvioSelected}
          hasFiltroQuincena
        />

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <ProductListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={envios.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
                checkbox={false}
              />
              <TableBody>
                {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  const {
                    id,
                    created_at,
                    updated_at,
                    shippingValue,
                    originalShippingValue,
                    city_from,
                    city_to,
                    state,
                    rate_provider,
                    provider,
                    trackingNumber,
                    purchase_id,
                    tracking_code,
                    label_code,
                    status,
                    payment_id,
                    empaquetadoDetalle,
                    user_id,
                    costo,
                    utilidad,
                    displayName,
                    descuentoIncrementoValue,
                    descuentoIncrementoType,
                    descuentoIncrementoCorpoValue,
                    utilidadEnvioLicen,
                    cuponValue,
                    utilidadEnvioDagpacket,
                    licenciatarioName
                  } = row;

                  const createDate = created_at.value
                    ? fDateTime(new Date(created_at.value))
                    : fDateTime(created_at.toDate());

                  const { utility = 0 } = empaquetadoDetalle || {};
                  const isItemSelected = selected.indexOf(id) !== -1;
                  const simplifiedProvider = providerAbrev(provider?.split('/')[0]);

                  return (
                    <TableRow
                      hover
                      key={id}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell align="right">
                        <EditarEnviosButton data={row} />
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                          }}
                        >
                          {status === 'CREATED' ? (
                            <>
                              <Typography fontSize="11px">
                                Dagpacket Code:{' '}
                                <Typography fontSize="11px" component="span" variant="subtitle2">
                                  {id}
                                </Typography>
                              </Typography>
                              <Typography fontSize="11px">
                                Track N°:{' '}
                                <Typography fontSize="11px" component="span" variant="subtitle2">
                                  {tracking_code || trackingNumber}
                                </Typography>
                              </Typography>
                              <Typography fontSize="11px">
                                Comp. ID:{' '}
                                <Typography fontSize="11px" component="span" variant="subtitle2">
                                  {purchase_id}
                                </Typography>{' '}
                              </Typography>{' '}
                            </>
                          ) : (
                            <Typography fontSize="13px">{id}</Typography>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>{licenciatarioName}</TableCell>
                      <TableCell>
                        {/* <UserBasicInfo user_id={user_id} /> */}
                        {displayName}
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {simplifiedProvider}-{rate_provider}
                        </Box>
                      </TableCell>
                      <TableCell style={{ minWidth: 140 }}>{createDate}</TableCell>
                      <TableCell align="right">{fCurrency(originalShippingValue)}</TableCell>
                      <TableCell align="right">{fCurrency(shippingValue)}</TableCell>
                      <TableCell align="right">{fCurrency(costo)}</TableCell>
                      <TableCell align="right">
                        {showModificacion(
                          descuentoIncrementoType,
                          descuentoIncrementoValue || descuentoIncrementoCorpoValue
                        )}

                        {/* {fCurrency(descuentoIncrementoValue || descuentoIncrementoCorpoValue)} */}
                      </TableCell>
                      <TableCell>{fCurrency(cuponValue)}</TableCell>
                      <TableCell>{fCurrency(utilidad + utility)}</TableCell>
                      <TableCell>
                        {utilidadEnvioDagpacket !== null && utilidadEnvioDagpacket !== undefined
                          ? fCurrency(Math.round(utilidadEnvioDagpacket + utility * 0.3))
                          : fCurrency(Math.round(utilidad * 0.3 + utility * 0.3))}
                      </TableCell>
                      <TableCell>
                        {utilidadEnvioLicen !== null && utilidadEnvioLicen !== undefined
                          ? fCurrency(Math.round(utilidadEnvioLicen + utility * 0.7))
                          : fCurrency(Math.round(utilidad * 0.7 + utility * 0.7))}
                      </TableCell>
                      <TableCell>{city_from}</TableCell>
                      <TableCell>{city_to}</TableCell>
                      <StatusTableCell data={row} />
                      {/* <TableCell align="right">
                          {state && <Chip sx={{ fontSize: '10px' }} label={state} size="small" color="info" />}
                        </TableCell> */}

                      <TableCell align="right">{status && <Label text={status} />}</TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isProductNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6}>
                      <Box sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
      {/* </Container> */}
    </Page>
  );
}

function StatusTableCell({ data }) {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const { state, payment_source, payment_id, payment_reason } = data;

  const getStatusClip = useCallback(() => {
    setLoading(true);
    clipPaymentConfirm(payment_id)
      .then((res) => {
        console.log('clip message', res);
        setLoading(false);
        setMessage('pagado clip');
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [payment_id]);

  useEffect(() => {
    if (payment_reason === 'REEMPLAZO-CLIP' && state === 'PAGADO') {
      setMessage('pagado clip');
    } else if (payment_source === 'CLIP' && state === 'PAGADO') {
      getStatusClip();
    } else {
      setMessage(state || '-');
    }
  }, [payment_source, getStatusClip, state, payment_reason]);
  // console.log(data);
  return (
    <TableCell align="right">
      {/* {state && <Chip sx={{ fontSize: '10px' }} label={state} size="small" color="info" />} */}
      {loading ? 'loading...' : <Chip sx={{ fontSize: '10px' }} label={message} size="small" color="info" />}
    </TableCell>
  );
}
